import gql from 'graphql-tag'

export const Q_GET_SHIFTS = gql`
query ($where:ListWhere) {
  shifts (where:$where) {
    name
    weekDays
    id
    tooLateClockIn
    tooLateLunchIn
    lunchInTolerance
    clockInTolerance
    clockOutTolerance
    lunchInTolerance
    isRestDay
    breakSkipped
    startMiss
    currentTeam
    clockIn
    clockOut
    lunchIn
    lunchOut
    schedules {
    id
           startDate
        endDate
      weekDay
      currentTeam
       member {
         firstName
         fullName
         status
         startDate
         endDate
       }
    }
    isActive
  }
}`
export const Q_GET_SHIFTS_ONLY = gql`
query ($where:ListWhere) {
  shifts (where:$where) {
    name
    weekDays,
    id,
    isRestDay
    breakSkipped
        startMiss

    currentTeam
    clockIn,
    clockOut,
    lunchIn
    lunchOut
    shiftType,
    shiftOption,
     tooLateClockIn
    tooLateLunchIn
    lunchInTolerance
    clockInTolerance
    clockOutTolerance
    lunchInTolerance
    isActive
  }
}`
export const M_CREATE_SHIFT = gql`mutation (
    $weekDays:[Int]
    $name:String
    $clockIn:String
    $clockOut:String
    $lunchIn:String
    $lunchOut:String
    $tooLateClockIn:String
    $tooLateLunchIn:String
    $currentTeam:String
    $clockInTolerance:Int
    $lunchInTolerance:Int
    $clockOutTolerance:Int
    $isRestDay: Boolean,
    $startMiss: Int,
      $shiftType: String,
    $shiftOption: String,

    ) {
  createShift (
    name:$name
    weekDays:$weekDays
    clockIn:$clockIn
    clockOut:$clockOut
    lunchIn:$lunchIn
    lunchOut:$lunchOut
    tooLateClockIn:$tooLateClockIn
    tooLateLunchIn:$tooLateLunchIn
    currentTeam:$currentTeam
    clockInTolerance: $clockInTolerance
    lunchInTolerance: $lunchInTolerance
    clockOutTolerance: $clockOutTolerance
    isRestDay: $isRestDay
    startMiss: $startMiss,
    shiftType: $shiftType,
    shiftOption: $shiftOption,
  )
  {
      name
    weekDays,
    id,
    isRestDay
    currentTeam
    clockIn,
    lunchIn,
    lunchOut
    clockOut,
     clockInTolerance,
    lunchInTolerance,
    clockOutTolerance,
    isRestDay,
      shiftType,
    shiftOption,
    isActive
    }
}`

export const M_UPDATE_SHIFT = gql`mutation (
    $id: Int!
    $weekDays:[Int]
    $name:String
    $clockIn:String
    $clockOut:String
    $lunchIn:String
    $lunchOut:String
    $tooLateClockIn:String
    $tooLateLunchIn:String
    $currentTeam:String
    $clockInTolerance:Int
    $lunchInTolerance:Int
    $clockOutTolerance:Int
    $isRestDay: Boolean,
    $startMiss: Int,
      $shiftType: String,
    $shiftOption: String,
  $isActive: Boolean,

    ) {
  updateShift (
    id:$id
    name:$name
    weekDays:$weekDays
    clockIn:$clockIn
    clockOut:$clockOut
    lunchIn:$lunchIn
    lunchOut:$lunchOut
    tooLateClockIn:$tooLateClockIn
    tooLateLunchIn:$tooLateLunchIn
    currentTeam:$currentTeam
    clockInTolerance: $clockInTolerance
    lunchInTolerance: $lunchInTolerance
    clockOutTolerance: $clockOutTolerance
    isRestDay: $isRestDay
    startMiss: $startMiss,
    shiftType: $shiftType,
    shiftOption: $shiftOption,
    isActive: $isActive
  )
  {
   id,
       name
    weekDays,
    id,
    isRestDay
    currentTeam
    clockIn,
    lunchIn,
    lunchOut
    clockOut,
     clockInTolerance,
    lunchInTolerance,
    clockOutTolerance,
    isRestDay,
      shiftType,
    shiftOption,
    isActive

    }
}`
export const M_DELETE_SHIFT = gql`mutation($where:ListWhere!) {
  deleteShift(where:$where)
}`
